class DetectionResult {
  private results: any[];
  private size: number;
  private lastFilledIndex: number;
  private average: number;

  constructor(size: number) {
    this.size = size;
    this.results = new Array(size);
    this.lastFilledIndex = -1;

    this.average = Math.ceil(size / 2);
  }

  getLast = () => {
    return {
      index: this.lastFilledIndex,
      data: this.results[this.lastFilledIndex],
    };
  };

  isFaceDetected = () => {
    let counter = 0;
    const prevIndex = this.lastFilledIndex - 1 < 0 ? this.size - 1 : this.lastFilledIndex - 1;

    if (
      this.results[prevIndex] &&
      this.results[prevIndex].predictions.length &&
      this.results[this.lastFilledIndex] &&
      this.results[this.lastFilledIndex].predictions.length
    ) {
      return true;
    } else {
      let index = this.lastFilledIndex;
      let iterations = 0;

      while (counter < this.average && iterations < this.size) {
        if (this.results[index] && this.results[index].predictions.length) {
          counter++;
        }
        index = index - 1 < 0 ? this.size - 1 : index - 1;
        iterations++;
      }

      return counter >= this.average;
    }
  };

  isMaskDetected = () => {
    let counter = 0;
    const prevIndex = this.lastFilledIndex - 1 < 0 ? this.size - 1 : this.lastFilledIndex - 1;

    if (
      this.results[prevIndex] &&
      this.results[prevIndex].maskDetection !== null &&
      this.results[this.lastFilledIndex] &&
      this.results[this.lastFilledIndex].maskDetection !== null &&
      this.results[prevIndex].maskDetection === this.results[this.lastFilledIndex].maskDetection
    ) {
      return this.results[prevIndex].maskDetection;
    } else {
      let index = this.lastFilledIndex;
      let iterations = 0;
      while (counter < this.average && iterations < this.size) {
        if (this.results[index] && this.results[index].maskDetection && this.results[index].maskDetection.isWithMask) {
          counter++;
        }
        index = index - 1 < 0 ? this.size - 1 : index - 1;
        iterations++;
      }

      return counter >= this.average;
    }
  };

  getTemperature = () => {
    let counter = 0;
    const prevIndex = this.lastFilledIndex - 1 < 0 ? this.size - 1 : this.lastFilledIndex - 1;

    if (
      this.results[prevIndex] &&
      this.results[prevIndex].temperature !== null &&
      this.results[this.lastFilledIndex] &&
      this.results[this.lastFilledIndex].temperature !== null
    ) {
      return this.results[this.lastFilledIndex].temperature;
    } else {
      let index = this.lastFilledIndex;
      let iterations = 0;
      while (counter < this.average && iterations < this.size) {
        if (this.results[index] && this.results[index].temperature) {
          counter++;
        }
        index = index - 1 < 0 ? this.size - 1 : index - 1;
        iterations++;
      }

      return counter >= this.average ? this.results[this.lastFilledIndex].temperature : null;
    }
  };

  getResults = () => {
    return [...this.results];
  };

  addData = (data: any) => {
    const index = (this.lastFilledIndex + 1) % this.size;

    this.results[index] = {
      imageDataToProcess: null,
      predictions: [],
      maskDetection: null,
      temperature: null,
      ...data,
    };

    this.lastFilledIndex = index;
  };

  updateDataByIndex = (index: number, type: string, data: any) => {
    this.results[index][type] = data;
  };
}

export default DetectionResult;
